<template>
  <div>
    <slot v-if="useSlot"></slot>
    <div v-else>
      <div v-if="selectSchoolData.id" class="data-line">
        <span class="data-font">{{ selectSchoolData.name }}</span>
        <span class="change-btn" @click="handleOpenSchool">更换学校</span>
      </div>
      <div v-else class="class-add-btn" @click="handleOpenSchool">选择学校</div>
    </div>
    <Modal
      v-model="modalShow"
      :width="800"
      title="选择学校"
      :footer-hide="true"
      :closable="false"
    >
      <div class="search-line">
        <Input
          v-model="schoolName"
          class="search-input"
          placeholder="请输入学校名称"
        ></Input>
        <Button type="primary" @click="handleSearchSchool">搜索</Button>
      </div>
      <RadioOrCheckboxTable
        :single-select-data.sync="selectSchoolDataModal"
        :table-column="schoolListColumn"
        :table-data="schoolList"
        :table-total="schoolPageInfo.total"
        :table-current="schoolPageInfo.pageNum"
        :table-loading="tableLoading"
        unique-key="id"
        @pageChange="handlePageChange"
      ></RadioOrCheckboxTable>
      <div class="modal-footer">
        <Button @click="handleCancleBtn">取消</Button>
        <Button type="primary" @click="handleSureBtn">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import operationAdmin from '@/request/operationAdmin/index.js';
import RadioOrCheckboxTable from '@c/Base/RadioOrCheckboxTable.vue';
import orderCenterApi from '@/request/orderCenter/index.js';
export default {
  components: {
    RadioOrCheckboxTable
  },
  props: {
    useSlot: {
      type: Boolean,
      default: false
    }, // 是否是否使用插槽
    value: {
      type: Object,
      default: () => { }
    },
    isCombo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      modalShow: false,
      schoolName: '',
      schoolList: [], // 学校数据列表
      schoolPageInfo: {
        total: 0,
        pageSize: 10,
        pageNum: 1
      }, // 学校数据的page信息
      tableLoading: false,
      schoolListColumn: [
        {
          title: '学校名称',
          key: 'name',
          minWidth: 200
        },
        {
          title: '所属行政区',
          key: 'areaName',
          minWidth: 200
        }
      ], // 学校列表表格column
      selectSchoolDataModal: {},
      portOrg: -1,
      firstGetData: false
    };
  },
  computed: {
    selectSchoolData: {
      get() {
        return this.value;
      },
      set(newVal) {
        this.$emit('input', newVal);
      }
    }
  },
  created() {
    this.portOrg = Number(localStorage.getItem('portOrg'));
  },
  methods: {
    handleSearchSchool() {
      this.schoolPageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.getSchoolListData();
    },
    handleOpenSchool() {
      this.schoolPageInfo = {
        total: 0,
        pageSize: 10,
        pageNum: 1
      };
      this.getSchoolListData();
      this.selectSchoolDataModal = { ...this.selectSchoolData };
      this.modalShow = true;
    },
    // 获取学校列表数据
    async getSchoolListData() {
      console.log('获取数据---', this.isCombo);
      const yearTermCode = localStorage.getItem('yearTermCode') ? localStorage.getItem('yearTermCode').split(',') : [];
      const params = {
        pageNum: this.schoolPageInfo.pageNum,
        pageSize: this.schoolPageInfo.pageSize,
        orgType: 1,
        orgName: this.schoolName,
        yearCode: yearTermCode.length ? yearTermCode[0] : '',
        termCode: yearTermCode.length ? yearTermCode[1] : ''
      };
      this.isCombo ? params.officeAreaCode = '440114' : '';
      this.tableLoading = true;
      let res = {};
      if (this.isCombo) {
        res = await operationAdmin.getListSchoolsNewByOfficeAreaCode(params);
      } else {
        res = await orderCenterApi.getWxOrgList(params);
      }

      this.tableLoading = false;
      if (res.status === 200) {
        this.schoolList = res.message.list.map(item => {
          item.id = item.orgId;
          item.name = item.orgName || item.name;
          return item;
        });
        this.schoolPageInfo.total = Number(res.message.total);
        !this.firstGetData ? this.$emit('firstLoadData', this.schoolList) : '';
        this.firstGetData = true;
      }
    },
    handlePageChange(page) {
      this.schoolPageInfo.pageNum = page;
      this.getSchoolListData();
    },
    handleSureBtn() {
      this.selectSchoolData = { ...this.selectSchoolDataModal };
      this.$nextTick(() => {
        this.$emit('postSchoolId', this.selectSchoolData.id);
        this.$emit('postSchoolRow', this.selectSchoolData);
        this.modalShow = false;
      });
    },
    handleCancleBtn() {
      this.modalShow = false;
    }
  }
};
</script>
<style lang="scss" scoped>
.search-line {
  margin-bottom: 16px;
  display: flex;
  .search-input {
    width: 160px;
    margin-right: 16px;
  }
}
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
  button + button {
    margin-left: 8px;
  }
}
.change-btn {
  color: #488ffa;
  margin-left: 16px;
  cursor: pointer;
}
.class-add-btn {
  text-align: center;
  border: 1px dashed #488ffa;
  color: #488ffa;
  font-size: 16px;
  border-radius: 4px;
  padding: 8px 12px;
  line-height: 12px;
  display: inline-block;
  vertical-align: middle;
  cursor: pointer;

  &::before {
    content: '+';
    margin-right: 8px;
  }
}
</style>
